/** Permission catalog for role management UI (mirrors api/src/lib/inflo-permissions.ts). */

export const PERMISSION_GROUPS = [
  {
    id: "operations",
    label: "Operations",
    permissions: [
      { id: "dashboard_access", label: "Dashboard" },
      { id: "equipment_receipt_access", label: "Receiving" },
      { id: "equipment_request_access", label: "Shipping" },
      { id: "equipment_checkout_access", label: "Equipment check-out" },
      { id: "transactions_access", label: "Transaction history" },
      { id: "reports_access", label: "Reports" },
      { id: "systems_menu_access", label: "Systems menu" },
    ],
  },
  {
    id: "admin",
    label: "Administration",
    permissions: [
      { id: "admin_users_access", label: "Users & team" },
      { id: "admin_roles_access", label: "Roles" },
      { id: "admin_systems_access", label: "Systems setup" },
      { id: "admin_parts_access", label: "Parts setup" },
      { id: "admin_bom_access", label: "BOM setup" },
      { id: "admin_transaction_types_access", label: "Transaction types" },
      { id: "admin_customers_access", label: "Customers" },
      { id: "admin_maintenance_access", label: "Maintenance mode" },
      { id: "admin_email_notifications_access", label: "Email notifications" },
    ],
  },
  {
    id: "account",
    label: "Account",
    permissions: [{ id: "billing_access", label: "Billing & subscription" }],
  },
] as const;

export const PERMISSION_LABELS: Record<string, string> = Object.fromEntries(
  PERMISSION_GROUPS.flatMap((g) => g.permissions.map((p) => [p.id, p.label])),
);
